import { instance, source } from "./axios/instance";

function RequestHandler() {
    async function get(path, headers) {
        return instance.get(path, {
            cancelToken: source.token,
            headers,
        });
    }

    async function post(path, body, headers) {
        return instance.post(path, body, {
            cancelToken: source.token,
            headers,
        });
    }

    async function put(path, body, headers) {
        return instance.put(path, body, { cancelToken: source.token, headers });
    }

    async function remove(path, body, headers) {
        return instance.delete(path, {
            data: body,
            cancelToken: source.token,
            headers,
        });
    }

    return {
        get,
        post,
        put,
        remove,
    };
}

export default RequestHandler();
